import React from "react";

import clsx from "clsx";
import Image from "next/image";

import FigureImage from "public/images/enerflo-solar-designs-integrations.png";

import HeroSection from "../../hero-section";
import styles from "./index.module.css";
import TimelineContent from "./timeline-content";

const title = "Design Tools";

const Designs = () => (
  <div className={clsx("timeline-section-wrapper", styles.timelineSectionWrapper)}>
    <HeroSection title={title} className={styles.timelineSection}>
      <div className={styles.timelineSectionGrid}>
        <TimelineContent
          title={title}
          description="Maybe you prefer Solo, Sighten, SolarGraf or HelioScope… or maybe you have an internal design team… or maybe you outsource designs offshore… whatever it may be, Enerflo supports your process to ensure accuracy, quality and quick turnarounds."
          link="/integrations/solar-design"
          icon={
            <Image
              src="/images/icons/designs.svg"
              alt="Icon - Enerflo Designs"
              layout="responsive"
              height={63}
              width={64}
              quality={100}
              className="crispImage"
            />
          }
        />
        <figure className={clsx(styles.timelineFigure, styles.offsetContent)}>
          <div className="mx-auto xs:w-2/3 relative md:w-[150%] md:right-[30%]">
            <Image
              src={FigureImage}
              alt="Enerflo integrates designs from the industry’s top solar design tools, internal designers and offshore teams to ensure accuracy, quality and quick turnarounds."
              layout="responsive"
              quality={100}
              placeholder="blur"
              className="crispImage"
              sizes="(min-width: 768px) 50vw, 100vw"
              lazyBoundary="400px"
            />
          </div>
        </figure>
      </div>
    </HeroSection>
  </div>
);

export default Designs;
